// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"a3f76e72","106":"13853f1f","157":"901c5dea","245":"f593406e","883":"527f7ac2"}[chunkId] + ".chunk.js";
};